



















import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Input extends Vue {
  @Prop({ required: false }) readonly invalid?: boolean;
  @Prop({ required: false, default: false }) readonly disabled?: boolean;
  @Prop({ required: false, default: true }) readonly autofocus?: boolean;
  @Prop({ required: false, default: '' }) readonly placeholder?: string;
  @Prop({ required: false, default: 'text' }) readonly type?: string;
  @Prop({ required: false, default: 'text' }) readonly inputmode?: string;
  isInFocus: boolean = false
  inputValue: number | string | null = null

  handleInput (event: any) {
    this.inputValue = event.target.value
    this.$emit('input', event.target.value)
  }

  handleFocus () {
    this.isInFocus = true
    this.$emit('focus')
  }

  handleBlur (event: FocusEvent) {
    this.isInFocus = false
  }

  get isFilled () {
    return !this.isInFocus && !!this.inputValue
  }

  get pattern () {
    return this.inputmode === 'numeric' ? '[0-9]*' : '*'
  }
}
